import React, {HTMLAttributes} from 'react';
import {useAuthStore} from '@/store/auth_store';
import {NotificationLink} from '@/components/pages/notifications/links/NotificationLink';
import PermissionsHelpers from '@/helpers/permissions_helpers';
import {parseNotificationMetadata} from "@/api/dto/notification";
import {Client} from "@/api/dto/client-profile";
import {Feature, FeatureNew, FeaturePermissionLevel} from "@/api/dto/permissions";
import {FeatureToggle, Roster} from "@/api/dto/dto";
import {useFeatureToggles} from "@/hooks/useFeatureToggles";
import DisplayHelpers from "@/helpers/display_helpers";

type Props = HTMLAttributes<HTMLAnchorElement> & {
  client: Client;
  metadata?: string;
  roster?: Roster;
};

export default function CareJourneyLink({ client, metadata, roster, ...props }: Props) {
  const { currentUser } = useAuthStore();
  const {checkBooleanToggle} = useFeatureToggles();

  const isNewPermissionsEnabled = checkBooleanToggle(FeatureToggle.CARECO_3415_NEW_USER_PERMISSIONS);

  const notificationMetadata = parseNotificationMetadata(metadata);

  const clientName = DisplayHelpers.formatName(client.firstName, undefined, client.lastName);
  const linkText = `${clientName}'s BH Care Management`;

  return roster && (isNewPermissionsEnabled ?
    PermissionsHelpers.canForUserFeaturePermissionRosterNew(
      currentUser!,
      roster,
      FeaturePermissionLevel.VIEW,
      FeatureNew.TASKS
    ) : PermissionsHelpers.canForUserFeaturePermissionRoster(
      currentUser!,
      roster,
      FeaturePermissionLevel.VIEW,
      Feature.TASKS
    )) ? (
      <NotificationLink to={`/${notificationMetadata.urlSuffix}`} {...props}>
        {linkText}
      </NotificationLink>
    ) : (
      <>{linkText}</>
    );
}
